var stringUtils = {};
stringUtils.getLastTimeStr = function(time, isFromNow) {
    var date = new Date(time);
    var fmt = "yyyy-MM-dd hh:mm";
    var o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
};
/****string extend string****/

/** 在字符串末尾追加字符串 **/
stringUtils.append = function(_self, str) {
    return _self.concat(str);
};
/** 删除指定索引位置的字符，索引无效将不删除任何字符 **/
stringUtils.deleteCharAt = function(_self, index) {
    if (index < 0 || index >= _self.length) {
        return _self.valueOf();
    } else if (index == 0) {
        return _self.substring(1, _self.length);
    } else if (index == _self.length - 1) {
        return _self.substring(0, _self.length - 1);
    } else {
        return _self.substring(0, index) + _self.substring(index + 1);
    }
};
/** 删除指定索引区间的字符串 **/
stringUtils.deleteString = function(_self, start, end) {
    if (start == end) {
        return _self.deleteCharAt(start);
    } else {
        if (start > end) {
            var temp = start;
            start = end;
            end = temp;
        }
        if (start < 0) {
            start = 0;
        }
        if (end > _self.length - 1) {
            end = _self.length - 1;
        }
        return (
            _self.substring(0, start) + _self.substring(end + 1, _self.length)
        );
    }
};
/** 检查字符串是否以subStr结尾 **/
stringUtils.endWith = function(_self, subStr) {
    if (subStr.length > _self.length) {
        return false;
    } else {
        return _self.lastIndexOf(subStr) == _self.length - subStr.length
            ? true
            : false;
    }
};
/** 比较两个字符串是否相等，也可以直接用 == 进行比较 **/
stringUtils.equal = function(_self, str) {
    if (_self.length != str.length) {
        return false;
    } else {
        for (var i = 0; i < _self.length; i++) {
            if (_self.charAt(i) != str.charAt(i)) {
                return false;
            }
        }
        return true;
    }
};
/** 比较两个字符串是否相等，不区分大小写 **/
stringUtils.equalIgnoreCase = function(_self, str) {
    var temp1 = _self.toLowerCase();
    var temp2 = str.toLowerCase();
    return temp1.equal(temp2);
};
/** 将指定的字符串插入到指定的位置后面，索引无效将直接追加到字符串的末尾 **/
stringUtils.insert = function(_self, ofset, subStr) {
    if (ofset < 0 || ofset >= _self.length - 1) {
        return _self.append(subStr);
    }
    return _self.substring(0, ofset + 1) + subStr + _self.substring(ofset + 1);
};
/** 判断字符串是否数字串 **/
stringUtils.isAllNumber = function(_self) {
    for (var i = 0; i < _self.length; i++) {
        if (_self.charAt(i) < "0" || _self.charAt(i) > "9") {
            return false;
        }
    }
    return true;
};
/** 将字符串反序排列 **/
stringUtils.reserve = function(_self) {
    var temp = "";
    for (var i = _self.length - 1; i >= 0; i--) {
        temp = temp.concat(_self.charAt(i));
    }
    return temp;
};
/** 将指定的位置的字符设置为另外指定的字符或字符串.索引无效将直接返回不做任何处理 **/
stringUtils.setCharAt = function(_self, index, subStr) {
    if (index < 0 || index > _self.length - 1) {
        return _self.valueOf();
    }
    return _self.substring(0, index) + subStr + _self.substring(index + 1);
};
/** 检查字符串是否以subStr开头 **/
stringUtils.startWith = function(_self, subStr) {
    if (subStr.length > _self.length) {
        return false;
    }
    return _self.indexOf(subStr) == 0 ? true : false;
};
/** 计算长度，每个汉字占两个长度，英文字符每个占一个长度 **/
stringUtils.charLength = function(_self) {
    var temp = 0;
    for (var i = 0; i < _self.length; i++) {
        if (_self.charCodeAt(i) > 255) {
            temp += 2;
        } else {
            temp += 1;
        }
    }
    return temp;
};
stringUtils.charLengthReg = function(_self) {
    return _self.replace(/[^\x00-\xff]/g, "**").length;
};
/** 去掉首尾空格 **/
stringUtils.trim = function(_self) {
    return _self.replace(/(^\s*)|(\s*$)/g, "");
};
/** 测试是否是数字 **/
stringUtils.isNumeric = function(_self) {
    var tmpFloat = parseFloat(this);
    if (isNaN(tmpFloat)) return false;
    var tmpLen = _self.length - tmpFloat.toString().length;
    return tmpFloat + "0".Repeat(tmpLen) == this;
};
/** 测试是否是整数 **/
stringUtils.isInt = function(_self) {
    if (this == "NaN") return false;
    return this == parseInt(this).toString();
};
/** 获取N个相同的字符串 **/
stringUtils.Repeat = function(_self, num) {
    var tmpArr = [];
    for (var i = 0; i < num; i++) tmpArr.push(this);
    return tmpArr.join("");
};
/** 合并多个空白为一个空白 **/
stringUtils.resetBlank = function(_self) {
    return _self.replace(/s+/g, " ");
};
/** 除去左边空白 **/
stringUtils.LTrim = function(_self) {
    return _self.replace(/^s+/g, "");
};
/** 除去右边空白 **/
stringUtils.RTrim = function(_self) {
    return _self.replace(/s+$/g, "");
};
/** 除去两边空白 **/
stringUtils.trim = function(_self) {
    return _self.replace(/(^s+)|(s+$)/g, "");
};
/** 保留数字 **/
stringUtils.getNum = function(_self) {
    return _self.replace(/[^d]/g, "");
};
/** 保留字母 **/
stringUtils.getEn = function(_self) {
    return _self.replace(/[^A-Za-z]/g, "");
};
/** 保留中文 **/
stringUtils.getCn = function(_self) {
    return _self.replace(/[^u4e00-u9fa5uf900-ufa2d]/g, "");
};
/** 得到字节长度 **/
stringUtils.getRealLength = function(_self) {
    return _self.replace(/[^x00-xff]/g, "--").length;
};
/** 从左截取指定长度的字串 **/
stringUtils.left = function(_self, n) {
    return _self.slice(0, n);
};
/** 从右截取指定长度的字串 **/
stringUtils.right = function(_self, n) {
    return _self.slice(_self.length - n);
};

stringUtils.compare = function(source, target) {
    let n = source.length;
    let m = target.length;
    if (n == 0) {
        return m;
    }

    if (m == 0) {
        return n;
    }

    let d = [];
    let max = m > n ? m : n;
    for (let i = 0; i < max + 1; i++) {
        d.push([]);
    }
    for (let i = 0; i <= n; i++) {
        d[i][0] = i;
    }
    for (let j = 0; j <= m; j++) {
        d[0][j] = j;
    }
    for (let i = 1; i <= n; i++) {
        let ch1 = source[i - 1];
        for (let j = 1; j <= m; j++) {
            let ch2 = target[j - 1];

            let temp = 1;
            if (ch1 == ch2) {
                temp = 0;
            }
            d[i][j] = Math.min(
                d[i - 1][j] + 1,
                d[i][j - 1] + 1,
                d[i - 1][j - 1] + temp
            );
        }
    }
    return d[n][m];
};

export default stringUtils;



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js